import { Container, Col, Row } from "reactstrap";
import * as SiteQL from "queries/site";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-cursor";
import SiteSchema from "@common/schema/site/public";
import * as widgets from "widgets/register";
import * as Section from "@repoflow/components/section";

// Hoisted: a config literal is a new object every render and the form provider
// rebuilds its widget tree underneath it. See ../../site/sections/section/edit.
const LIST_FIELDS = {
  "/Public/Site": {
    fields: ["siteId", "title", "updatedAt"],
  },
};

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add
          </Link>
        </Col>
      </Row>

      <div className="mt-4"></div>

      <List
        path={"viewer.account.sites"}
        query={SiteQL.list}
        variables={params}
        schema={SiteSchema}
        widgets={widgets}
        target={{ $ref: "/Public/Site" }}
        empty={"No sites yet."}
        config={LIST_FIELDS}
        content={({ item: { siteId } }) => (
          <>
            {/* Lands on the site's PAGES, not on its own screen. The tab strip
                inside a site puts Pages first because it is what a person comes
                back to — and this is the coming back. Landing at the site's
                root instead opened Configuration, the LAST tab, so the first
                thing seen on entering a site was the screen it says to visit
                once. Configuration is still one tab away, and still where
                Remove is. */}
            <Link className={"btn btn-primary"} to={`${base}/${siteId}/page`}>
              Open
            </Link>{" "}
          </>
        )}
      />
    </Container>
  );
};
